// extracted by mini-css-extract-plugin
export var emailBlockLink = "_h1-0";